// ---------------------------------------------------------------------------
// contentSafety — client-side report/hide/block state for user-generated
// content (App Store Guideline 1.2: UGC apps must offer content REPORTING
// and the ability to BLOCK abusive users, alongside the server-side
// moderation that runs at post time).
//
// v1 keeps this local (localStorage): hiding reported content and blocking
// a user takes effect INSTANTLY on this device — which is what the
// guideline is protecting — while the report itself goes to the team via
// the report-content edge function for real action (content removal,
// account suspension server-side).
// ---------------------------------------------------------------------------

const HIDDEN_KEY = "pleasant.hiddenContent.v1";
const BLOCKED_KEY = "pleasant.blockedUsers.v1";

function readSet(key: string): Set<string> {
  try {
    const raw = localStorage.getItem(key);
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.filter((x) => typeof x === "string") : []);
  } catch {
    return new Set();
  }
}

function writeSet(key: string, set: Set<string>): void {
  try {
    localStorage.setItem(key, JSON.stringify([...set].slice(0, 2000)));
  } catch {
    /* quota — silent */
  }
}

/** Hide one piece of content (tip/photo id) on this device. */
export function hideContent(id: string): void {
  const s = readSet(HIDDEN_KEY);
  s.add(id);
  writeSet(HIDDEN_KEY, s);
}

/** Block a user — all their content disappears on this device. */
export function blockUser(userId: string): void {
  const s = readSet(BLOCKED_KEY);
  s.add(userId);
  writeSet(BLOCKED_KEY, s);
}

/** Filter predicate for rendering UGC lists. */
export function isContentVisible(item: { id: string; user_id?: string | null }): boolean {
  if (readSet(HIDDEN_KEY).has(item.id)) return false;
  if (item.user_id && readSet(BLOCKED_KEY).has(item.user_id)) return false;
  return true;
}
